import { useState } from "react";
import AlertNotice from "shared/AlertNotice";
import { Section } from "shared/layout";
import Card from "shared/Card";
import Button from "shared/Button";
import Amway from "../Tabs/Amway";
import { Danger } from "react-ikonate";

export default function NonMember({ iboNumber }) {
  const [showAmway, setShowAmway] = useState(false);

  return (
    <>
      <AlertNotice icon={<Danger />} title="No Membership">
        This IBO does not have a Membership.
      </AlertNotice>

      <Card>
        {showAmway ? (
          <Section>
            <header>
              <h3>Amway</h3>
            </header>
            <Amway iboNumber={iboNumber} />
          </Section>
        ) : (
          <Button
            onClick={() => {
              setShowAmway(true);
            }}
          >
            Show Amway Info
          </Button>
        )}
      </Card>
    </>
  );
}
